<template>
    <!-- the charcoal band that opens every page: the title in Squada One, lit by the teal-to-blue gradient -->
    <section class="cl-hero" :class="{ 'cl-hero--compact': compact }">
        <div class="cl-hero__inner">
            <div v-if="$slots.media" class="cl-hero__media">
                <slot name="media" />
            </div>
            <div class="cl-hero__text">
                <div v-if="eyebrow" class="cl-hero__eyebrow">{{ eyebrow }}</div>
                <h1 class="cl-hero__title">{{ title }}</h1>
                <div v-if="subtitle" class="cl-hero__subtitle">{{ subtitle }}</div>
                <slot name="meta" />
            </div>
            <div v-if="$slots.aside" class="cl-hero__aside">
                <slot name="aside" />
            </div>
        </div>
        <div v-if="$slots.default" class="cl-hero__bar">
            <slot />
        </div>
    </section>
</template>

<script>
    export default {
        name: 'PageHero',
        props: {
            title: {
                type: String,
                default: ''
            },
            eyebrow: {
                type: String,
                default: null
            },
            subtitle: {
                type: String,
                default: null
            },
            compact: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.cl-hero {
    position: relative;
    overflow: hidden;
    color: #fff;
    text-align: left;
    background:
        radial-gradient(circle at 88% 0%, rgba(3, 229, 183, 0.32) 0%, rgba(3, 229, 183, 0) 42%),
        radial-gradient(circle at 0% 100%, rgba(3, 122, 222, 0.3) 0%, rgba(3, 122, 222, 0) 48%),
        #232323;
}

/* the centre circle of a court, barely there */
.cl-hero::before {
    content: '';
    position: absolute;
    right: -120px;
    top: -160px;
    width: 420px;
    height: 420px;
    border: 2px solid rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.cl-hero::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4px;
    background: linear-gradient(90deg, #03e5b7 0%, #037ade 74%);
}

.cl-hero__inner {
    position: relative;
    display: flex;
    align-items: center;
    gap: 24px;
    max-width: 1240px;
    margin: 0 auto;
    padding: 40px 24px 32px;
}

.cl-hero--compact .cl-hero__inner {
    padding: 26px 24px 22px;
}

.cl-hero__media {
    flex: 0 0 auto;
}

.cl-hero__text {
    flex: 1 1 auto;
    min-width: 0;
}

.cl-hero__eyebrow {
    display: inline-block;
    margin-bottom: 8px;
    padding: 2px 10px;
    border-radius: 3px;
    background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
}

.cl-hero__title {
    margin: 0;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 3rem;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    overflow-wrap: anywhere;
}

.cl-hero__subtitle {
    margin-top: 8px;
    font-family: Roboto, Arial, sans-serif;
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.7);
}

.cl-hero__aside {
    flex: 0 0 auto;
}

.cl-hero__bar {
    position: relative;
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 24px 24px;
}

@media (max-width: 700px) {
    .cl-hero__inner {
        flex-wrap: wrap;
        gap: 14px;
        padding: 24px 16px 20px;
    }

    .cl-hero__title {
        font-size: 2.1rem;
    }

    .cl-hero__aside {
        width: 100%;
    }

    .cl-hero__bar {
        padding: 0 16px 18px;
    }
}
</style>
